class CountdownTimer extends HTMLElement {
  connectedCallback() {
    if (!this.values) {
      this.target = new Date(this.dataset.target).getTime();
      this.units = this.querySelector('.countdown__units');
      this.finished = this.querySelector('.countdown__finished');
      this.values = {};
      this.querySelectorAll('.countdown__value').forEach((el) => {
        this.values[el.dataset.unit] = el;
        this.splitDigits(el, el.textContent.trim());
      });
    }
    if (Number.isNaN(this.target)) return;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  splitDigits(el, text) {
    el.textContent = '';
    for (const ch of text) {
      const span = document.createElement('span');
      span.className = 'countdown__digit';
      span.textContent = ch;
      el.appendChild(span);
    }
  }

  setValue(unit, number) {
    const text = String(number).padStart(2, '0');
    const el = this.values[unit];
    if (!el) return;
    const digits = el.querySelectorAll('.countdown__digit');
    if (digits.length !== text.length) {
      this.splitDigits(el, text);
      return;
    }
    digits.forEach((digit, i) => {
      if (digit.textContent === text[i]) return;
      digit.textContent = text[i];
      digit.classList.remove('is-ticking');
      void digit.offsetWidth;
      digit.classList.add('is-ticking');
    });
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
    this.setValue('days', Math.floor(remaining / 86400));
    this.setValue('hours', Math.floor((remaining % 86400) / 3600));
    this.setValue('minutes', Math.floor((remaining % 3600) / 60));
    this.setValue('seconds', remaining % 60);

    if (remaining === 0) {
      clearInterval(this.interval);
      this.units.hidden = true;
      this.finished.hidden = false;
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
